export default {
    intro: 'ลองเดาคำศัพท์จากพยัญชนะต้นและความหมายเป็นเบาะแสดูสิ!',
    meaning: 'ความหมาย',
    example: 'ตัวอย่าง',
    emptyExample: 'ไม่มีประโยคตัวอย่าง',
    table: {
        question: 'คำศัพท์',
        emptyMessage: 'ไม่มีเนื้อหา',
        answerRate: 'อัตราการตอบถูก',
    },
    student: {
        selectionGuide: 'ดูข้อมูลนี้แล้วบอกได้ไหมว่าเป็นคำศัพท์ใด?',
        know: 'รู้จัก!',
        dontKnow: 'ไม่รู้',
        submit: 'ส่ง',
        next: 'ถัดไป',
        inputGuide: 'ลองพิมพ์คำศัพท์ที่คิดไว้ดูสิ!',
        inputPlaceholder: 'กรอกคำตอบ',
        meaningN: 'ความหมาย {n}',
        imageN: 'รูปภาพ {n}',
        videoN: 'วิดีโอ {n}',
        additionalMaterials: 'สื่อเพิ่มเติม',
    },
    result: {
        myAnswer: 'คำตอบของฉัน:',
        know: 'รู้จัก',
        dontKnow: 'ไม่รู้',
        dontKnowBracket: '(ไม่รู้)',
    },
    stats: {
        mostIncorrect: 'คำศัพท์ที่ตอบผิดบ่อย',
        vocabulary: 'คำศัพท์',
        meaning: 'ความหมาย',
        accuracy: 'อัตราการตอบถูก',
        moreN: 'และอีก {n} คำ',
    },
    reactions: {
        knowSelect: [
            'โอ้! ดูมั่นใจจังเลยนะ?',
            'ดีเลย! มาลองดูกันไหม?',
            'เยี่ยม! มาดูกันว่าถูกจริงไหม!',
            'ยอดเยี่ยม! จะเป็นคำศัพท์ใดนะ?',
            'เจ๋งมาก! มาดูคำตอบกัน!',
        ],
        correct: [
            'ตอบถูก! เก่งมากเลย!',
            'ว้าว! รู้แบบเป๊ะเลยนะ!',
            'ถูกต้อง! สุดยอดไปเลย!',
            'ยอดเยี่ยม! ตอบถูกเป๊ะเลย!',
            'เก่งมาก! เจ๋งสุดๆ!',
        ],
        dontKnowSelect: [
            'ไม่เป็นไร! มาหาคำตอบด้วยกัน!',
            'ไม่ต้องกังวล! ดูประโยคตัวอย่างแล้วจะรู้เอง!',
            'ไม่เป็นไร! ดูคำใบ้แล้วจะรู้เอง!',
        ],
        maxAttempts: 'ไม่เป็นไรนะ มาหาด้วยกันว่าเป็นคำศัพท์ใด!',
        maxAttemptsNext: 'มาดูกันว่าเป็นคำศัพท์ใด แล้วไปที่คำศัพท์ถัดไปกัน!',
    },
    teacher: {
        modal: {
            clearConfirm: {
                title: 'จะล้างคำศัพท์ที่รออยู่ทั้งหมดไหม?',
                message: 'คำศัพท์ที่รอลงทะเบียนจะถูกลบทั้งหมด ต้องการดำเนินการต่อหรือไม่?',
            },
            closeConfirm: {
                title: 'จะลบโจทย์ที่กรอกไว้ไหม?',
                message: 'หากปิด คำศัพท์ในคิวจะหายไปทั้งหมด ต้องการดำเนินการต่อหรือไม่?',
            },
            questionDelete: {
                title: 'จะลบโจทย์ไหม?',
                // {word}: 삭제 대상 문항의 표제어. 활동에서 영구 제거됨을 안내.
                message: "โจทย์ '{word}' จะถูกลบออกจากกิจกรรม ต้องการดำเนินการต่อหรือไม่?",
            },
            waitItemDelete: {
                title: 'จะลบคำศัพท์ที่รออยู่ไหม?',
                // {word}: 삭제 대상 대기 어휘. 대기열에서만 제거되며 활동에는 영향 없음을 안내.
                message: "จะลบ '{word}' ออกจากคิว ต้องการดำเนินการต่อหรือไม่?",
            },
            // {count}: BE가 사전 중복으로 건너뛴 어휘 수
            duplicateNotice: 'คำศัพท์ {count} คำที่ลงทะเบียนไว้แล้วไม่ถูกเพิ่ม',
            // {count}: 뜻이 없어 등록 불가로 건너뛴 어휘 수
            skippedNotice: 'คำศัพท์ {count} คำไม่ถูกลงทะเบียนเพราะไม่มีความหมาย',
            // 혼합(뜻없는 어휘 + 뜻있는 어휘) 등록 시 확인 모달
            mixedEmptyConfirm: {
                title: 'จะลงทะเบียนไหม?',
                // {empty}: 뜻 비어 등록 불가 개수
                line1: 'คำศัพท์ {empty} คำที่ไม่มีความหมายจะไม่ถูกเพิ่ม',
                // {valid}: 실제 등록될 개수
                line2: 'จะลงทะเบียนเฉพาะ {valid} คำที่เหลือในกิจกรรมไหม?',
            },
            // 뜻없는 어휘만 있을 때 등록 불가 안내
            onlyEmptyNotice: {
                title: 'ไม่สามารถลงทะเบียนได้',
                message: 'ไม่มีคำศัพท์ที่ลงทะเบียนได้ เหลือแต่คำศัพท์ที่ไม่มีความหมายเท่านั้น',
            },
            registerFailed: 'ลงทะเบียนไม่สำเร็จ',
        },
    },
};
